import { useState, useEffect } from "react";
import React from 'react';
import Task from "../components/Task";
import Header from "../components/Header";

function ContactScreen() {

  React.useEffect(() => {
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = "https://analytics.preprod.qalmo.fr/js/container_LnaaM1aY.js";
    s.parentNode.insertBefore(g, s);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const [activeTab, setActiveTab] = useState("user");
  const [formError, setFormError] = useState("");
  const [formData, setFormData] = useState({
    pseudo: "",
    email: "",
    objet: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);  

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    setFormError("");

    if (!formData.pseudo.trim()) newErrors.pseudo = "Pseudo requis";
    if (!validateEmail(formData.email)) newErrors.email = "Email invalide";
    if (!formData.objet.trim()) newErrors.objet = "Objet requis";
    if (!formData.message.trim()) newErrors.message = "Message requis";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setFormError("Veuillez remplir correctement tous les champs obligatoires.");
      return;
    }

    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({
      event: "event",
      eventCategory: "Formulaire",
      eventAction: "Envoi",
      eventName: activeTab === "user" ? "Contact User" : "Contact Entreprise",
    });

    try {
      const response = await fetch('/sendmail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      const text = await response.text();

      if (response.ok) {
        setFormError("Message envoyé");
        setIsSubmitted(true);
        setErrors({});
      } else {
        setFormError(text || "Erreur lors de l'envoi du message.");
      }
    } catch (error) {
      setFormError("Erreur réseau : impossible d'envoyer le message.");
    }
  };

  function newDate(nb){
    const date = new Date();
    date.setDate(date.getDate() + nb);
    return date.toISOString().split('T')[0];
  }

  return (
    <>
      <Header />
      <div className="min-h-screen overflow-hidden bg-[url('../assets/fond.png')] bg-repeat bg-top bg-auto flex justify-center font-fraunces">
        <div className="lg:mt-70 mt-48">
          <div className="relative lg:w-[425px] lg:h-[800px] w-[400px] h-[800px] rounded-[40px] bg-black shadow-xl border border-gray-300">
            {/* Encoche */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-4 bg-gray-800 rounded-b-xl z-10" />

            <div className="absolute inset-2.5 bg-white rounded-[36px] p-4 overflow-hidden">
              
              <h2 className="text-xl text-center mb-6 text-[#1A1A1A]">
                Contacte-nous
              </h2>

              {/* Switch User / Entreprise */}
              <div className="flex justify-around mb-6">
                {/* USER Tab */}
                <button onClick={() => setActiveTab("user")} className="flex flex-col items-center focus:outline-none" >
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${ activeTab === "user" ? "stroke-black" : "stroke-gray-400" }`} >
                    {/* Icône user */}
                    <path d="M8.1001 17.5301V14.8701" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.77002 16.2002H9.43002" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.99782 11.2002C6.71782 11.2002 5.43882 11.6882 4.46182 12.6652C2.50882 14.6182 2.50882 17.7832 4.46182 19.7362C6.41482 21.6892 9.57982 21.6892 11.5328 19.7362H13.6668C15.6198 21.6892 18.7848 21.6892 20.7378 19.7362C22.6908 17.7832 22.6908 14.6182 20.7378 12.6652C19.7618 11.6882 18.4818 11.2002 17.2018 11.2002H7.99782V11.2002Z" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17.9351 17.0166C18.0731 17.0166 18.1851 17.1286 18.1841 17.2666C18.1841 17.4046 18.0721 17.5166 17.9341 17.5166C17.7961 17.5166 17.6841 17.4046 17.6841 17.2666C17.6851 17.1286 17.7971 17.0166 17.9351 17.0166" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.8008 14.8828C15.9388 14.8828 16.0508 14.9948 16.0498 15.1328C16.0498 15.2708 15.9378 15.3828 15.7998 15.3828C15.6618 15.3828 15.5498 15.2708 15.5498 15.1328C15.5508 14.9948 15.6628 14.8828 15.8008 14.8828" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12.6001 11.2002V9.7002C12.6001 8.3202 13.7191 7.2002 15.1001 7.2002C16.4811 7.2002 17.6001 6.0812 17.6001 4.7002V3.2002" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className={`text-sm ${ activeTab === "user" ? "text-black" : "text-gray-400" }`} >
                    User
                  </span>
                  <div className={`h-1 w-10 mt-1 rounded-full transition-all ${ activeTab === "user" ? "bg-black" : "bg-transparent" }`} />
                </button>

                {/* ENTREPRISE Tab */}
                <button onClick={() => setActiveTab("entreprise")} className="flex flex-col items-center focus:outline-none" >
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${ activeTab === "entreprise" ? "stroke-black" : "stroke-gray-400" }`} >
                    {/* Icône entreprise */}
                    <path fillRule="evenodd" clipRule="evenodd" d="M20.2419 8.49945L14.2419 3.83245C13.1589 2.98945 11.6419 2.98945 10.5579 3.83245L4.5579 8.49945C3.8269 9.06745 3.3999 9.94145 3.3999 10.8674V18.2004C3.3999 19.8574 4.7429 21.2004 6.3999 21.2004H18.3999C20.0569 21.2004 21.3999 19.8574 21.3999 18.2004V10.8674C21.3999 9.94145 20.9729 9.06745 20.2419 8.49945Z" strokeWidth="1.8" />
                    <path d="M16.3994 14.4385C14.1894 16.6485 10.6074 16.6485 8.39941 14.4385" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className={`text-sm ${ activeTab === "entreprise" ? "text-black" : "text-gray-400" }`} >
                    Entreprise
                  </span>
                  <div className={`h-1 w-10 mt-1 rounded-full transition-all ${ activeTab === "entreprise" ? "bg-black" : "bg-transparent" }`} />
                </button>
              </div>
              <div className="border-t border-black/20 my-2 w-full -mt-6"></div>
              {isSubmitted ? (
                <div className="space-y-2"> 
                  <div className="font-bold text-xl mt-5">
                    Tâches complétées
                  </div>
                  <Task name="Contacter qalmo" category={2} importance={2} limitDate={newDate(0)}/>
                  <div className="text-center text-green-600 text-md">
                    Merci pour votre message ! Nous vous répondrons rapidement.
                  </div>
                </div>
              ) : (
                <form className="space-y-5 py-2" onSubmit={handleSubmit}>
                  {activeTab === "user" ? (
                    <>
                      <Task name="Ton pseudo" category={0} formulaire={true} value={formData.pseudo} onChange={(val) => setFormData({ ...formData, pseudo: val})} error={errors.pseudo}/>
                      <Task name="Ton email" category={1} formulaire={true} value={formData.email} onChange={(val) => setFormData({ ...formData, email: val})} error={errors.email} />
                      <Task name="Objet de la demande" category={2} formulaire={true} raison={true} entreprise={false} value={formData.objet} onChange={(val) => setFormData({ ...formData, objet: val})} error={errors.objet} />
                      <Task name="Ton message" category={3} formulaire={true} message={true} value={formData.message} onChange={(val) => setFormData({ ...formData, message: val})} error={errors.message} />
                    </>
                  ) : (
                    <>
                      <Task name="Votre entreprise" category={0} formulaire={true} value={formData.pseudo} onChange={(val) => setFormData({ ...formData, pseudo: val})} error={errors.pseudo}/>
                      <Task name="Votre email" category={1} formulaire={true} value={formData.email} onChange={(val) => setFormData({ ...formData, email: val})} error={errors.email}/>
                      <Task name="Objet de la demande" category={2} formulaire={true} raison={true} entreprise={true} value={formData.objet} onChange={(val) => setFormData({ ...formData, objet: val})} error={errors.objet} />
                      <Task name="Votre message" category={3} formulaire={true} message={true} value={formData.message} onChange={(val) => setFormData({ ...formData, message: val})} error={errors.message}/>
                    </>
                  )}
                  {formError && (
                    <p className="text-red-500 text-sm text-center -mt-2">{formError}</p>
                  )}
                  <button type="submit" className="w-full py-3 bg-[#6C63FF] text-white rounded-xl font-medium text-sm hover:bg-[#574fd8] transition" >
                    Envoyer
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactScreen;